<template>
  <div v-if="jobRoleHeaders.length > 0">
    <section
      v-for="(header, index) in jobRoleHeaders"
      :key="index"
    >
      <h3>{{ header }}</h3>
      <template v-for="tag in jobRoles">
        <div
          v-if="tag.item.parent === header"
          :key="tag.item.id"
          class="Form-field Form-field--checkbox"
        >
          <input
            :id="`job_tag_${tag.item.slug}`"
            v-model="selectedTagSlugs"
            :value="tag.item.slug"
            type="checkbox"
            class="Form-input"
            @change="handleTagSelection(tag.item)"
          >
          <label
            :for="`job_tag_${tag.item.slug}`"
            class="Form-label"
          >{{ tag.item.name }}</label>
        </div>
      </template>
    </section>
  </div>
  <div v-else>
    <section>
      <p>No job role tags match your search</p>
    </section>
  </div>
</template>

<script>
import Fuse from 'fuse.js/dist/fuse';

export default {
  props: {
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    availableTags: {
      type: Object,
      default() {
        return {};
      },
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
    searchTerm: {
      type: String,
      default: '',
    },
    searchKeys: {
      type: Array,
      default() {
        return ['name', 'parent'];
      },
    },
  },
  emits: ['rmp:tag-selector:remove-tag', 'rmp:tag-selector:add-tag'],
  data() {
    return {
      selectedTags: [],
      selectedTagSlugs: [],
      tagResults: [],
      filteredResults: [],
    };
  },
  computed: {
    jobRoles() {
      if ((this.searchTerm !== '') && this.isSearchable) {
        return this.fuseResults.search(this.searchTerm);
      }
      return this.tagResults.map((tag) => { return { item: { ...tag } }; });
    },
    jobRoleHeaders() {
      const headers = this.jobRoles.map((result) => result.item.parent);
      const uniqueHeaders = headers.filter((item, index) => headers.indexOf(item) === index);
      return uniqueHeaders;
    },
    fuseResults() {
      return new Fuse([...this.tagResults], {
        threshold: 0.3,
        location: 0,
        distance: 100,
        minMatchCharLength: 2,
        keys: this.searchKeys,
      });
    },
  },

  watch: {
    tags: {
      deep: true,
      immediate: true,
      handler() {
        this.selectedTags = [...this.tags];
        this.selectedTagSlugs = this.tags.map((tag) => tag.slug);
        this.addParentPropsToTags();
      },
    },
  },

  methods: {
    handleTagSelection(tag) {
      if (this.selectedTagSlugs.indexOf(tag.slug) > -1) {
        this.$emit('rmp:tag-selector:add-tag', tag);
      } else {
        this.$emit('rmp:tag-selector:remove-tag', tag);
      }
    },
    addParentPropsToTags() {
      // Parse data to add { parent: tag } to each tag object
      this.tagResults = [];
      console.log('AVAILABLE TAGS ', this.availableTags);
      Object.keys(this.availableTags).forEach((tag) => {
        const tags = this.availableTags[tag].map((option) => ({ ...option, parent: tag }));
        this.tagResults.push(...tags);
      });

      this.filteredResults = [...this.tagResults];
    },
  },
};
</script>

<style scoped>

</style>
